import { defineComponent as _defineComponent } from 'vue';
import LegacySearch from '~/components/_next/template/search/LegacySearch.vue';
import AlgoliaSearch from '~/components/_next/template/search/AlgoliaSearch.vue';
export default /*#__PURE__*/_defineComponent({
  __name: '_term',
  setup: function setup(__props) {
    var context = useNuxt2App();
    var $flag = context.$flag;
    var isAlgoliaEnabled = $flag.get('algoliaSearchAndCategories', false);
    return {
      __sfc: true,
      context: context,
      $flag: $flag,
      isAlgoliaEnabled: isAlgoliaEnabled,
      LegacySearch: LegacySearch,
      AlgoliaSearch: AlgoliaSearch
    };
  }
});